module.exports = __webpack_public_path__ + "img/Eselei.aed11179.jpg";